

import NavLink from "./NavLink";
import NavLogo from "./NavLogo";
import { StyledNavbar } from "../Styles/StyledNavbar";
import { StyledNavbarLinks } from "../Styles/StyledNavbarLinks";
import {useEffect, useState} from "react";
import Login from "./Login";
import Modal from "./Modal";
import Link from "./Link";

interface NavProps {
  className: string;
  src: string;
  showLogin?: boolean;
}

const Navbar = ({ className, src, showLogin = false }: NavProps) => {

  const [closeLoginSignal, setCloseLoginSignal] = useState(0);
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('isLoggedIn');
    console.log(loggedInUser);
    setUserIsLoggedIn(loggedInUser !== null);
  }, []);

  return (
    <StyledNavbar className={className}>
      <NavLogo src={src} />
      <StyledNavbarLinks>
        {!userIsLoggedIn ?<>
        <Modal closedFromChild={closeLoginSignal}
               trigger={<NavLink href="#"  isActive={false}>
          Přihlášení učitele
        </NavLink>} content={<Login onClick={() => {
          setCloseLoginSignal((s) => s + 1)
          setUserIsLoggedIn(true);
        }} />} />

          </>
          : <><NavLink href="#"  isActive={false} onClick={()=>{
            localStorage.removeItem('isLoggedIn')
            setUserIsLoggedIn(false)
            window.location.reload();
          }}>
            Odhlásit
          </NavLink>
            <NavLink href="/metodika.pdf"  isActive={false}>
              Metodika
            </NavLink>
          </>}


      </StyledNavbarLinks>



    </StyledNavbar>

  );
};

export default Navbar;
